import { z } from 'zod';
import { IAssetCategoryId } from './IAssetCategory';

export const IAssetTypeId = {
  RealEstate: 1,
  BankAccount: 2,
  Cash: 3,
  Loan: 4,
  Mortgage: 5,
  Depot: 6,
  Other: 7,
} as const;

export const IAssetTypeSchema = z.object({
  idAssetType: z
    .number()
    .refine(val => Object.values(IAssetTypeId).includes(val as any), {
      message: 'Invalid Asset Type ID',
    }),
  AssetType: z.string(),
  idAssetCategory: z
    .number()
    .refine(val => Object.values(IAssetCategoryId).includes(val as any), {
      message: 'Invalid Asset Category ID',
    }),
});

export type IAssetType = z.infer<typeof IAssetTypeSchema>;

export type IAssetTypeId = (typeof IAssetTypeId)[keyof typeof IAssetTypeId];

export const AssetTypeIdSchema = z.union([
  z.literal(IAssetTypeId.RealEstate),
  z.literal(IAssetTypeId.BankAccount),
  z.literal(IAssetTypeId.Cash),
  z.literal(IAssetTypeId.Loan),
  z.literal(IAssetTypeId.Mortgage),
  z.literal(IAssetTypeId.Depot),
  z.literal(IAssetTypeId.Other),
]);
export type AssetTypeId = z.infer<typeof AssetTypeIdSchema>;
